<template>
  <CompLoading v-if="isLoading" />

  <div v-show="!isLoading">
    <!-- 메인 -->
    <!-- :style="{
        backgroundImage: `url(${homeMainInfo.homeMainInfoDetail.homeMainDetailList.mainImg})`,
      }" -->
    <section
      :class="
        idxLeSiteMain == '138'
          ? 'bg-[linear-gradient(to_bottom,#FFFFFF_0%,#DEEAFA_100%)] bg-no-repeat pc:bg-[image:url(@/assets/images/main/main/gangwon-bg.png),linear-gradient(to_bottom,#FFFFFF_0%,#DEEAFA_100%)] pc:bg-[length:auto_100%,100%_100%] pc:bg-[position:center_center,center_center]'
          : 'bg-[url(@/assets/images/main/main/bg-m.png)] bg-cover bg-[center_top] bg-no-repeat pc:bg-[url(@/assets/images/main/main/bg-p.png)]'
      "
    >
      <div class="mx-auto max-w-[1100px] px-[18px] pb-10 pt-[66px] pc:pb-[60px] pc:pt-[126px]">
        <div :class="idxLeSiteMain == '138' ? 'mb-[26px]' : 'mb-[267px]'" class="pc:mb-[62px]">
          <img
            v-if="idxLeSiteMain == '138'"
            src="@/assets/images/main/main/gangwon-lang.png"
            alt=""
            class="mx-auto mb-5 w-[175px] pc:mx-0 pc:mb-3.5"
          />

          <p
            :class="[
              idxLeSiteMain == '132' ? 'pc:text-[58px]' : 'pc:text-[62px]',
              idxLeSiteMain == '138' ? 'text-[40px]' : 'text-[44px]',
            ]"
            class="mb-2.5 text-center font-bold leading-[50px] text-[#101010] pc:mb-[34px] pc:text-left pc:leading-[76px]"
          >
            <template v-for="(line, index) in sugangNameLines" :key="index"> <br v-if="index > 0" />{{ line }} </template>
          </p>

          <p class="text-center font-medium text-[#101010] pc:text-left pc:text-xl pc:leading-[30px]">
            <template v-if="idxLeSiteMain == '138'">
              “미래를 준비하는 글로벌 의사소통 역량”<br class="pc:hidden" />
              학습자 수준에 맞는<br class="hidden pc:block" />
              단계별 화상수업으로<br class="pc:hidden" />
              자신감 있는 외국어 소통 역량을 키웁니다.
            </template>
            <template v-else-if="idxLeSiteMain == '195'">
              1:1 실시간 화상수업,<br />학습자의 눈높이에 맞춘 한국어 교육을 지원합니다.
            </template>
            <template v-else>
              현지 원어민 강사님과 실시간 수업,<br />4단계 완전학습으로 영어 실력을 한 단계 끌어올리세요!
            </template>
          </p>
        </div>

        <div v-if="idxLeSiteMain == '138'" class="-mx-[18px] flex justify-center overflow-hidden pc:hidden">
          <img src="@/assets/images/main/main/gangwon-con.png" alt="" class="h-[310px] w-[589px] max-w-none shrink-0" />
        </div>

        <div class="space-y-5">
          <!-- 수강신청 바로가기 사용안함일 때 -->
          <ul
            v-if="homeMainInfo.homeMainInfoDetail.homeMainDetailList.isButton == 'N'"
            class="flex w-full flex-col gap-2.5 pc:flex-row pc:gap-3"
          >
            <li
              @click="idxLeSiteMain == '52' ? homeMainInfo.openGlobalsugang() : homeMainInfo.goEnrolmentJunior()"
              :class="idxLeSiteMain == '138' ? 'bg-[#3880F2]' : 'bg-[#F97316]'"
              class="flex cursor-pointer items-center justify-between rounded-[22px] py-[18px] pl-[22px] pr-6 pc:w-[302px] pc:py-[18px] pc:pl-5 pc:pr-[18px]"
            >
              <div>
                <p
                  :class="idxLeSiteMain == '138' ? 'text-[#3880F2]' : 'text-[#F97316]'"
                  class="mb-1.5 w-fit rounded-full bg-white px-2.5 py-1 font-bold"
                >
                  Junior
                </p>

                <p class="pl-1 text-xl font-bold text-white">수강신청 바로가기</p>
              </div>

              <div class="w-8">
                <img src="@/assets/images/main/main/go1.png" alt="icon" />
              </div>
            </li>

            <li
              v-if="homeMainInfo.homeMainInfoDetail.homeMainDetailList.mainContent === 'adult'"
              @click="homeMainInfo.goEnrolmentAdult()"
              class="flex cursor-pointer items-center justify-between rounded-[22px] bg-[#111111] py-[18px] pl-[22px] pr-6 pc:w-[302px] pc:py-[18px] pc:pl-5 pc:pr-[18px]"
            >
              <div>
                <div class="mb-1.5 flex items-center gap-1.5">
                  <p class="w-fit rounded-full bg-white px-2.5 py-1 font-bold text-[#111111]">성인</p>
                  <p class="text-[15px] text-[#B2B2B2]">*20세 이상</p>
                </div>

                <p class="pl-1 text-xl font-bold text-white">수강신청 바로가기</p>
              </div>

              <div class="w-8">
                <img src="@/assets/images/main/main/go1.png" alt="icon" />
              </div>
            </li>
          </ul>

          <!-- 수강신청 바로가기 사용함일 때 -->
          <div v-if="homeMainInfo.homeMainInfoDetail.homeMainDetailList.isButton == 'Y'">
            <ul class="space-y-4">
              <li class="space-y-4">
                <ul
                  v-if="homeMainInfo.homeMainInfoDetail.button1Link && homeMainInfo.homeMainInfoDetail.button1Name"
                  class="flex w-full flex-col gap-2.5 pc:flex-row pc:gap-3"
                >
                  <li
                    @click="goToSugang(homeMainInfo.homeMainInfoDetail.button1Link)"
                    class="flex cursor-pointer items-center justify-between gap-6 rounded-[22px] bg-white py-2.5 pl-[18px] pr-6 pc:w-[302px] pc:flex-none pc:px-[18px] pc:py-3.5"
                  >
                    <div>
                      <p class="text-lg font-bold text-[#101010]">{{ homeMainInfo.homeMainInfoDetail.button1Name }}</p>
                    </div>

                    <div class="w-4">
                      <img src="@/assets/images/main/main/go2.png" alt="icon" />
                    </div>
                  </li>
                </ul>

                <ul
                  v-if="homeMainInfo.homeMainInfoDetail.button2Link && homeMainInfo.homeMainInfoDetail.button2Name"
                  class="flex w-full flex-col gap-2.5 pc:flex-row pc:gap-3"
                >
                  <li
                    @click="goToSugang(homeMainInfo.homeMainInfoDetail.button2Link)"
                    class="flex cursor-pointer items-center justify-between gap-6 rounded-[22px] bg-white py-2.5 pl-[18px] pr-6 pc:w-[302px] pc:flex-none pc:px-[18px] pc:py-3.5"
                  >
                    <div>
                      <p class="text-lg font-bold text-[#101010]">{{ homeMainInfo.homeMainInfoDetail.button2Name }}</p>
                    </div>

                    <div class="w-4">
                      <img src="@/assets/images/main/main/go2.png" alt="icon" />
                    </div>
                  </li>
                </ul>
              </li>

              <li class="space-y-4">
                <ul
                  v-if="homeMainInfo.homeMainInfoDetail.button3Link && homeMainInfo.homeMainInfoDetail.button3Name"
                  class="flex w-full flex-col gap-2.5 pc:flex-row pc:gap-3"
                >
                  <li
                    @click="goToSugang(homeMainInfo.homeMainInfoDetail.button3Link)"
                    class="flex cursor-pointer items-center justify-between gap-6 rounded-[22px] bg-white py-2.5 pl-[18px] pr-6 pc:w-[302px] pc:flex-none pc:px-[18px] pc:py-3.5"
                  >
                    <div>
                      <p class="text-lg font-bold text-[#101010]">{{ homeMainInfo.homeMainInfoDetail.button3Name }}</p>
                    </div>

                    <div class="w-4">
                      <img src="@/assets/images/main/main/go2.png" alt="icon" />
                    </div>
                  </li>
                </ul>

                <ul
                  v-if="homeMainInfo.homeMainInfoDetail.button4Link && homeMainInfo.homeMainInfoDetail.button4Name"
                  class="flex w-full flex-col gap-2.5 pc:flex-row pc:gap-3"
                >
                  <li
                    @click="goToSugang(homeMainInfo.homeMainInfoDetail.button4Link)"
                    class="flex cursor-pointer items-center justify-between gap-6 rounded-[22px] bg-white py-2.5 pl-[18px] pr-6 pc:w-[302px] pc:flex-none pc:px-[18px] pc:py-3.5"
                  >
                    <div>
                      <p class="text-lg font-bold text-[#101010]">{{ homeMainInfo.homeMainInfoDetail.button4Name }}</p>
                    </div>

                    <div class="w-4">
                      <img src="@/assets/images/main/main/go2.png" alt="icon" />
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </div>

          <!-- 수강신청 내역확인, 나의 학습방, 공지사항 -->
          <ul class="flex flex-col gap-2 pc:flex-row pc:gap-3">
            <li
              @click="idxLeSiteMain == '52' ? homeMainInfo.opencheckGlobalsugang() : homeMainInfo.goClassList()"
              class="flex cursor-pointer items-center justify-between gap-6 rounded-[22px] bg-white py-2.5 pl-[18px] pr-6 pc:w-[302px] pc:flex-none pc:px-[18px] pc:py-3.5"
            >
              <div class="flex grow items-center gap-3">
                <img src="@/assets/images/main/main/icon-history.png" alt="" class="w-[46px]" />

                <p class="text-lg font-bold text-[#101010]">수강신청 내역확인</p>
              </div>

              <div class="w-3.5 flex-none">
                <img src="@/assets/images/main/main/go2.png" alt="" />
              </div>
            </li>

            <li
              @click="homeMainInfo.goMyClass('/myClass')"
              class="flex cursor-pointer items-center justify-between gap-6 rounded-[22px] bg-white py-2.5 pl-[18px] pr-6 pc:w-[302px] pc:flex-none pc:px-[18px] pc:py-3.5"
            >
              <div class="flex grow items-center gap-3">
                <img src="@/assets/images/main/main/icon-my.png" alt="" class="w-[46px]" />

                <p class="text-lg font-bold text-[#101010]">나의 학습방</p>
              </div>

              <div class="w-3.5 flex-none">
                <img src="@/assets/images/main/main/go2.png" alt="" />
              </div>
            </li>

            <li
              v-if="idxLeSiteMain != '52'"
              @click="goNoticeList()"
              class="flex cursor-pointer items-center justify-between gap-6 rounded-[22px] bg-white py-2.5 pl-[18px] pr-6 pc:w-full pc:px-[18px] pc:py-3.5"
            >
              <div class="flex grow items-center gap-3">
                <img src="@/assets/images/main/main/icon-notice.png" alt="" class="w-[46px]" />

                <div class="flex grow flex-col gap-1 pc:flex-row pc:items-center pc:gap-2.5">
                  <p class="text-lg font-bold text-[#101010] pc:flex-none">공지사항</p>

                  <div class="relative h-6 overflow-hidden pc:grow">
                    <TransitionGroup name="notice-slide" tag="div" class="relative">
                      <p
                        v-for="notice in visibleNotices"
                        :key="`notice-${noticeRollingIndex}-${notice.idxNotice}`"
                        @click.stop="homeMainInfo.getNotice"
                        class="absolute left-0 top-0 line-clamp-1 w-full text-[#868686]"
                      >
                        {{ notice.title }}
                      </p>
                    </TransitionGroup>
                  </div>
                </div>
              </div>

              <div class="w-3.5 flex-none">
                <img src="@/assets/images/main/main/go2.png" alt="" />
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <!-- pc 우측 퀵메뉴 -->
    <div class="fixed right-0 top-1/2 z-[2] hidden -translate-y-1/2 pc:block">
      <ul
        class="grid grid-cols-1 divide-y divide-solid divide-[#E6E6E6] rounded-l-[26px] bg-white py-2 pl-3.5 pr-2.5 shadow-[0_0_30px_rgba(0,0,0,0.1)]"
      >
        <li @click="goSite('https://zoom.us/test')" class="flex cursor-pointer flex-col items-center py-4">
          <img src="@/assets/images/main/quick/icon-zoom.png" alt="" class="w-8" />
          <p class="text-center text-sm leading-4 text-[#333333]">Zoom<br />테스트</p>
        </li>

        <li @click="goPage('/learningSupport/faq')" class="flex cursor-pointer flex-col items-center py-4">
          <img src="@/assets/images/main/quick/icon-faq.png" alt="" class="w-8" />
          <p class="text-center text-sm leading-4 text-[#333333]">FAQ</p>
        </li>

        <li
          v-if="idxLeSiteMain != '52'"
          @click="goSite('https://pp7lz.channel.io/home')"
          class="flex cursor-pointer flex-col items-center py-4"
        >
          <img src="@/assets/images/main/quick/icon-q.png" alt="" class="w-8" />
          <p class="text-center text-sm leading-4 text-[#333333]">1:1 질문</p>
        </li>

        <!-- 195 는 all-content 섹션을 숨기므로 스크롤 대상이 없어 함께 숨김 -->
        <li
          v-if="idxLeSiteMain != '52' && idxLeSiteMain != '195'"
          @click="goSmooth('all-content')"
          class="flex cursor-pointer flex-col items-center py-4"
        >
          <img src="@/assets/images/main/quick/icon-intro.png" alt="" class="w-8" />
          <p class="text-center text-sm leading-4 text-[#333333]">화상영어<br />소개</p>
        </li>

        <li
          v-if="idxLeSiteMain != '52' && idxLeSiteMain != '195'"
          @click="goSite('https://www.carrotenglish.com/')"
          class="flex cursor-pointer flex-col items-center py-4"
        >
          <img src="@/assets/images/main/quick/icon-adult.png" alt="" class="w-8" />
          <p class="text-center text-sm leading-4 text-[#333333]">당근영어<br />성인</p>
        </li>

        <li
          v-if="idxLeSiteMain != '52' && idxLeSiteMain != '195'"
          @click="goSite('https://carrotjunior.kr/')"
          class="flex cursor-pointer flex-col items-center py-4"
        >
          <img src="@/assets/images/main/quick/icon-junior.png" alt="" class="w-8" />
          <p class="text-center text-sm leading-4 text-[#333333]">당근영어<br />주니어</p>
        </li>
      </ul>
    </div>

    <!-- 성인, 주니어에 따라 컨텐츠 달라지는 영역 -->
    <section v-if="idxLeSiteMain != '52' && idxLeSiteMain != '138' && idxLeSiteMain != '195'" id="all-content">
      <article class="pc-con-wrapper1 py-24 pc:py-32">
        <!-- mb-10 pc:mb-16 -->
        <div class="flex justify-center">
          <div class="flex flex-col gap-5 pc:gap-10">
            <p class="rounded-lg bg-orange-500 p-3 text-center text-xl font-medium text-white pc:p-4 pc:text-4xl">
              "영어, 어디서 시작했냐고 다들 물어봐요."
            </p>
            <p class="text-center text-3xl font-bold text-neutral-950 pc:text-6xl pc:leading-tight">
              당근영어로 커지는<br /><span class="text-orange-500">영어 회화 자부심!</span>
            </p>
          </div>
        </div>
      </article>

      <!-- 자녀를 위한 최고의 선택 - 주니어일 때 노출 -->
      <article
        v-if="
          homeMainInfo.homeMainInfoDetail.homeMainDetailList.mainContent === 'junior' &&
          idxLeSiteMain != '91' &&
          idxLeSiteMain != '138'
        "
        class="overflow-hidden bg-zinc-100 py-24 pc:py-32"
      >
        <div class="pc-con-wrapper1 curriculum relative">
          <div class="mb-10 flex justify-center pc:mb-16">
            <div class="flex flex-col gap-5 pc:gap-10">
              <p class="text-center text-xl font-medium text-neutral-950 pc:text-4xl">
                레벨, 학습, 관심사까지!<br />선택의 폭이 넓은 커리큘럼 LINE UP
              </p>
              <p class="text-center text-3xl font-bold text-neutral-950 pc:text-6xl pc:leading-tight">
                자녀를 위한 최고의 선택<br /><span class="text-orange-500">주니어 프리미엄 커리큘럼</span>
              </p>
            </div>
          </div>
          <swiper
            @swiper="setThumbsSwiper"
            :loop="false"
            :slidesPerView="7"
            :freeMode="false"
            class="curriculum-list mb-8 rounded-[50px] bg-white p-4 shadow-lg"
          >
            <swiper-slide><p class="cursor-pointer py-7 text-center text-xl font-bold">일반회화</p></swiper-slide>
            <swiper-slide><p class="cursor-pointer py-7 text-center text-xl font-bold">영어매거진</p></swiper-slide>
            <swiper-slide
              ><p class="relative cursor-pointer py-7 text-center text-xl font-bold">
                영어인터뷰
                <span class="absolute -top-1 right-6 rounded-2xl bg-red-600 px-2.5 py-1 text-sm text-yellow-300">new!</span>
              </p></swiper-slide
            >
            <swiper-slide><p class="cursor-pointer py-7 text-center text-xl font-bold">직업탐구</p></swiper-slide>
            <swiper-slide><p class="cursor-pointer py-7 text-center text-xl font-bold">토론심화</p></swiper-slide>
          </swiper>

          <swiper
            :loop="true"
            :spaceBetween="10"
            :autoHeight="true"
            :thumbs="{ swiper: thumbsSwiper }"
            :modules="modules"
            class="curriculum-content rounded-[50px] bg-white shadow-lg"
          >
            <swiper-slide>
              <div class="p-7 pc:p-24">
                <div class="mb-2 pc:mb-4">
                  <p class="text-2xl font-bold pc:text-3xl">주니어 일반회화</p>
                </div>
                <p class="mb-14 text-lg pc:text-xl">
                  언어 발달 단계에 맞춰
                  <span class="font-bold text-orange-600">개발된 16권의 코스북</span>으로<br /><span
                    class="font-bold text-orange-600"
                    >영어가 모국어처럼 편해질</span
                  >
                  수 있는 주니어 맞춤 프로그램
                </p>
                <div class="inline-block w-2/3">
                  <div class="relative z-[2] ml-3 flex">
                    <img src="@/assets/images/main/curriculum/slide1-con.png" alt="image" class="w-min" />
                  </div>
                  <div class="relative -mt-24 inline-block rounded-2xl px-7 pb-7 pt-24 pc:w-80 pc:bg-gray-200">
                    <p class="mb-2.5 text-xl font-bold">It's Me!</p>
                    <p class="mb-5 text-sm text-orange-600">Level 1 ~ 7</p>
                    <p
                      class="inline-block cursor-pointer rounded-lg bg-orange-600 px-2.5 py-1 text-sm text-white"
                      @click="goPage('/courseIntroduce/junior')"
                    >
                      과정 미리보기
                    </p>
                  </div>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="p-7 pc:p-24">
                <div class="mb-2 pc:mb-4">
                  <p class="text-2xl font-bold pc:text-3xl">주니어 영어매거진</p>
                </div>
                <p class="mb-14 text-lg pc:text-xl">
                  매월 발간되는
                  <span class="font-bold text-orange-600">수준별 영어 교육 전문 매거진</span>으로<br /><span
                    class="font-bold text-orange-600"
                    >영어 활용 능력과 비판적 사고력</span
                  >을 향상 시킬 수 있는 프로그램
                </p>
                <div class="inline-block w-2/3">
                  <div class="relative z-[2] ml-3 flex">
                    <img src="@/assets/images/main/curriculum/slide2-con.png" alt="image" class="w-min" />
                  </div>
                  <div class="relative -mt-24 inline-block rounded-2xl px-7 pb-7 pt-24 pc:w-80 pc:bg-gray-200">
                    <p class="mb-2.5 text-xl font-bold">NE Times</p>
                    <p class="mb-5 text-sm text-orange-600">Level 2 ~ 7</p>
                    <p
                      class="inline-block cursor-pointer rounded-lg bg-orange-600 px-2.5 py-1 text-sm text-white"
                      @click="goPage('/courseIntroduce/junior')"
                    >
                      과정 미리보기
                    </p>
                  </div>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="p-7 pc:p-24">
                <div class="mb-2 flex items-center gap-2 pc:mb-4">
                  <p class="rounded-full bg-orange-600 px-2 py-1.5 text-2xl font-bold text-white">NEW</p>
                  <p class="text-2xl font-bold pc:text-3xl">주니어 영어인터뷰</p>
                </div>
                <p class="mb-14 text-lg pc:text-xl">
                  <span class="font-bold text-orange-600">질문 유형을 사전에 습득</span>하고
                  <span class="font-bold text-orange-600">실전 답변 스킬</span>을 향상함으로써<br /><span
                    class="font-bold text-orange-600"
                    >해외 유학 또는 구제 학교 입학의 가능성</span
                  >을 열어주는 맞춤 인터뷰 프로그램
                </p>
                <div class="w-2/3">
                  <img src="@/assets/images/main/curriculum/slide3-con.png" alt="image" class="w-min" />
                </div>
                <p
                  class="inline-block cursor-pointer rounded-lg bg-orange-600 px-2.5 py-1 text-sm text-white"
                  @click="goPage('/courseIntroduce/junior')"
                >
                  과정 미리보기
                </p>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="p-7 pc:p-24">
                <div class="mb-2 pc:mb-4">
                  <p class="text-2xl font-bold pc:text-3xl">글로벌 직업탐구</p>
                </div>
                <p class="mb-14 text-lg pc:text-xl">
                  80년 역사의
                  <span class="font-bold text-orange-600">커리어 솔루션 프로그램 Kuder</span>를<br />기반으로 만들어진
                  <span class="font-bold text-orange-600">주니어 전용 글로벌 직업 이해도 향상</span>
                  프로그램
                </p>
                <div class="inline-block w-2/3">
                  <div class="relative z-[2] ml-3 flex">
                    <img src="@/assets/images/main/curriculum/slide4-con.png" alt="image" class="w-min" />
                  </div>
                  <div class="relative -mt-24 inline-block rounded-2xl px-7 pb-7 pt-24 pc:w-80 pc:bg-gray-200">
                    <p class="mb-2.5 text-xl font-bold">My Career World</p>
                    <p class="mb-5 text-sm text-orange-600">Level 2 ~ 7</p>
                    <p
                      class="inline-block cursor-pointer rounded-lg bg-orange-600 px-2.5 py-1 text-sm text-white"
                      @click="goPage('/courseIntroduce/junior')"
                    >
                      과정 미리보기
                    </p>
                  </div>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="p-7 pc:p-24">
                <div class="mb-2 pc:mb-4">
                  <p class="text-2xl font-bold pc:text-3xl">주니어 토론심화</p>
                </div>
                <p class="mb-14 text-lg pc:text-xl">
                  관심사에 맞춘
                  <span class="font-bold text-orange-600">48개의 다양한 핵심 토픽</span>을 통해
                  <span class="font-bold text-orange-600">통합적 사고력</span>과<br /><span class="font-bold text-orange-600"
                    >스피킹 실력을 함께 향상</span
                  >시킬 수 있는 토론 프로그램
                </p>
                <div class="inline-block w-2/3">
                  <div class="relative z-[2] ml-3 flex">
                    <img src="@/assets/images/main/curriculum/slide5-con.png" alt="image" class="w-min" />
                  </div>
                  <div class="relative -mt-24 inline-block rounded-2xl px-7 pb-7 pt-24 pc:w-80 pc:bg-gray-200">
                    <p class="mb-2.5 text-xl font-bold">365 Think&Talk</p>
                    <p class="mb-5 text-sm text-orange-600">Level 3 ~ 7</p>
                    <p
                      class="inline-block cursor-pointer rounded-lg bg-orange-600 px-2.5 py-1 text-sm text-white"
                      @click="goPage('/courseIntroduce/junior')"
                    >
                      과정 미리보기
                    </p>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </article>

      <!-- py-24 pc:py-32 -->
      <article class="overflow-hidden py-12 pc:py-16">
        <p
          class="mb-[30px] text-center text-3xl font-bold text-neutral-950 tablet:mb-11 pc:mb-[54px] pc:text-6xl pc:leading-tight"
        >
          당근영어만의<br />
          프리미엄 학습 솔루션
        </p>

        <div class="-mx-[18px] pc:-mx-0">
          <img src="@/assets/images/main/solution/icon1.png" alt="" class="mx-auto mb-3 w-14 tablet:mb-[18px] tablet:w-[70px]" />

          <p class="mb-[30px] text-center text-xl font-bold leading-tight tablet:mb-9 tablet:text-[32px] pc:mb-[68px]">
            캐럿 AI 학습 솔루션!
          </p>

          <div
            class="relative bg-[url(@/assets/images/main/solution/bg-ai-m.png)] bg-[length:822px_394px] bg-[center_top_38px] bg-no-repeat tablet:bg-none"
          >
            <div class="hidden tablet:block pc:hidden">
              <div class="absolute left-1/2 top-[50px] w-[1580px] -translate-x-1/2 overflow-hidden">
                <img src="@/assets/images/main/solution/bg-ai-t.png" alt="" class="mx-auto h-[467px] w-[1580px] object-cover" />
              </div>
            </div>

            <div class="hidden pc:block">
              <div class="absolute left-1/2 top-[59px] w-full -translate-x-1/2 overflow-hidden">
                <img src="@/assets/images/main/solution/bg-ai-p.png" alt="" class="mx-auto h-[577px] w-[1952px] object-cover" />
              </div>
            </div>

            <div
              class="relative mx-auto mb-[42px] h-[475px] w-[250px] overflow-hidden rounded-[28px] shadow-[20px_30px_28px_rgba(0,0,0,0.22)] tablet:mb-10 tablet:h-[558px] tablet:w-[294px] tablet:rounded-[35px] pc:mb-12 pc:h-[695px] pc:w-[364px] pc:rounded-[40px]"
            >
              <swiper
                :thumbs="{ swiper: thumbsCon4Swiper }"
                :autoplay="{ delay: 5000, disableOnInteraction: false }"
                :loop="true"
                :modules="modules"
                class="rounded-lg"
              >
                <swiper-slide class="bg-[#F3F4F6]">
                  <div class="pc:hidden">
                    <img src="@/assets/images/main/solution/img1-m.png" alt="" />
                  </div>

                  <div class="hidden pc:block">
                    <img src="@/assets/images/main/solution/img1-p.png" alt="" />
                  </div>
                </swiper-slide>

                <swiper-slide class="bg-[#F3F4F6]">
                  <div class="pc:hidden">
                    <img src="@/assets/images/main/solution/img2-m.png" alt="" />
                  </div>

                  <div class="hidden pc:block">
                    <img src="@/assets/images/main/solution/img2-p.png" alt="" />
                  </div>
                </swiper-slide>

                <swiper-slide class="bg-[#F3F4F6]">
                  <div class="pc:hidden">
                    <img src="@/assets/images/main/solution/img3-m.png" alt="" />
                  </div>

                  <div class="hidden pc:block">
                    <img src="@/assets/images/main/solution/img3-p.png" alt="" />
                  </div>
                </swiper-slide>

                <swiper-slide class="bg-white">
                  <div class="pc:hidden">
                    <img src="@/assets/images/main/solution/img4-m.png" alt="" />
                  </div>

                  <div class="hidden pc:block">
                    <img src="@/assets/images/main/solution/img4-p.png" alt="" />
                  </div>
                </swiper-slide>
              </swiper>

              <div class="pc:hidden">
                <img src="@/assets/images/main/solution/phone-m.png" alt="" class="absolute inset-0 z-[1]" />
              </div>

              <div class="hidden pc:block">
                <img src="@/assets/images/main/solution/phone-p.png" alt="" class="absolute inset-0 z-[1]" />
              </div>
            </div>

            <div class="px-[18px] pc:px-0">
              <swiper
                @swiper="setThumbsCon4Swiper"
                :slidesPerView="4"
                :watchSlidesProgress="true"
                :modules="modules"
                class="title-slide"
              >
                <swiper-slide class="cursor-pointer">
                  <div class="flex flex-col items-center gap-2 tablet:gap-3 pc:gap-5">
                    <img src="@/assets/images/main/solution/title1-off.png" alt="" class="w-16 tablet:w-[90px] pc:w-[98px]" />
                    <p
                      class="text-center text-sm font-medium leading-tight text-[#A1A3A8] tablet:text-base tablet:leading-tight pc:text-lg pc:leading-tight"
                    >
                      AI<br />
                      페르소나
                    </p>
                  </div>
                </swiper-slide>

                <swiper-slide class="cursor-pointer">
                  <div class="flex flex-col items-center gap-2 tablet:gap-3 pc:gap-5">
                    <img src="@/assets/images/main/solution/title2-off.png" alt="" class="w-16 tablet:w-[90px] pc:w-[98px]" />
                    <p
                      class="text-center text-sm font-medium leading-tight text-[#A1A3A8] tablet:text-base tablet:leading-tight pc:text-lg pc:leading-tight"
                    >
                      AI<br />
                      Speaking
                    </p>
                  </div>
                </swiper-slide>

                <swiper-slide class="cursor-pointer">
                  <div class="flex flex-col items-center gap-2 tablet:gap-3 pc:gap-5">
                    <img src="@/assets/images/main/solution/title3-off.png" alt="" class="w-16 tablet:w-[90px] pc:w-[98px]" />
                    <p
                      class="text-center text-sm font-medium leading-tight text-[#A1A3A8] tablet:text-base tablet:leading-tight pc:text-lg pc:leading-tight"
                    >
                      Shadowing<br />
                      Practice
                    </p>
                  </div>
                </swiper-slide>

                <swiper-slide class="cursor-pointer">
                  <div class="flex flex-col items-center gap-2 tablet:gap-3 pc:gap-5">
                    <img src="@/assets/images/main/solution/title4-off.png" alt="" class="w-16 tablet:w-[90px] pc:w-[98px]" />
                    <p
                      class="text-center text-sm font-medium leading-tight text-[#A1A3A8] tablet:text-base tablet:leading-tight pc:text-lg pc:leading-tight"
                    >
                      AI 개인 맞춤<br />
                      학습 분석
                    </p>
                  </div>
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </div>
      </article>

      <article class="overflow-hidden py-24 pc:py-32">
        <p
          class="mb-[18px] text-center text-lg font-medium leading-tight text-[#6D7076] tablet:mb-[18px] tablet:text-2xl pc:mb-7 pc:text-[26px]"
        >
          정답만 맞추는 영어는 그만!
        </p>

        <p
          class="mb-7 text-center text-[34px] font-bold tablet:mb-[54px] tablet:text-[42px] tablet:leading-[54px] pc:mb-[90px] pc:text-[60px] pc:leading-[76px]"
        >
          영어로 생각하며<br class="tablet:hidden" />
          말할 수 있는<br />
          <span class="text-[#FF6714]">4단계</span> 완전학습의 효과
        </p>

        <div class="-mx-5 mb-[22px] tablet:mb-7 pc:-mx-0 pc:mb-[60px]">
          <swiper
            :autoplay="{
              delay: 4000,
              disableOnInteraction: false,
            }"
            :loop="true"
            :slidesPerView="'auto'"
            :centeredSlides="true"
            :navigation="{
              prevEl: '.step-button-prev-custom',
              nextEl: '.step-button-next-custom',
            }"
            :modules="modules"
            class="step-swiper"
          >
            <swiper-slide class="!h-auto !w-[285px] tablet:!w-[332px] pc:!w-[972px]">
              <div class="pc:hidden">
                <img src="@/assets/images/main/4step/img1-m.png" alt="" />
              </div>

              <div class="hidden pc:block">
                <img src="@/assets/images/main/4step/img1-p.png" alt="" />
              </div>
            </swiper-slide>

            <swiper-slide class="!h-auto !w-[285px] tablet:!w-[332px] pc:!w-[972px]">
              <div class="pc:hidden">
                <img src="@/assets/images/main/4step/img2-m.png" alt="" />
              </div>

              <div class="hidden pc:block">
                <img src="@/assets/images/main/4step/img2-p.png" alt="" />
              </div>
            </swiper-slide>

            <swiper-slide class="!h-auto !w-[285px] tablet:!w-[332px] pc:!w-[972px]">
              <div class="pc:hidden">
                <img src="@/assets/images/main/4step/img3-m.png" alt="" />
              </div>

              <div class="hidden pc:block">
                <img src="@/assets/images/main/4step/img3-p.png" alt="" />
              </div>
            </swiper-slide>

            <swiper-slide class="!h-auto !w-[285px] tablet:!w-[332px] pc:!w-[972px]">
              <div class="pc:hidden">
                <img src="@/assets/images/main/4step/img4-m.png" alt="" />
              </div>

              <div class="hidden pc:block">
                <img src="@/assets/images/main/4step/img4-p.png" alt="" />
              </div>
            </swiper-slide>

            <swiper-slide class="!h-auto !w-[285px] tablet:!w-[332px] pc:!w-[972px]">
              <div class="pc:hidden">
                <img src="@/assets/images/main/4step/img1-m.png" alt="" />
              </div>

              <div class="hidden pc:block">
                <img src="@/assets/images/main/4step/img1-p.png" alt="" />
              </div>
            </swiper-slide>

            <swiper-slide class="!h-auto !w-[285px] tablet:!w-[332px] pc:!w-[972px]">
              <div class="pc:hidden">
                <img src="@/assets/images/main/4step/img2-m.png" alt="" />
              </div>

              <div class="hidden pc:block">
                <img src="@/assets/images/main/4step/img2-p.png" alt="" />
              </div>
            </swiper-slide>

            <swiper-slide class="!h-auto !w-[285px] tablet:!w-[332px] pc:!w-[972px]">
              <div class="pc:hidden">
                <img src="@/assets/images/main/4step/img3-m.png" alt="" />
              </div>

              <div class="hidden pc:block">
                <img src="@/assets/images/main/4step/img3-p.png" alt="" />
              </div>
            </swiper-slide>

            <swiper-slide class="!h-auto !w-[285px] tablet:!w-[332px] pc:!w-[972px]">
              <div class="pc:hidden">
                <img src="@/assets/images/main/4step/img4-m.png" alt="" />
              </div>

              <div class="hidden pc:block">
                <img src="@/assets/images/main/4step/img4-p.png" alt="" />
              </div>
            </swiper-slide>
          </swiper>
        </div>

        <ul class="flex justify-center gap-8 tablet:gap-[38px] pc:gap-[42px]">
          <li class="step-button-prev-custom size-11 tablet:size-[52px]">
            <img src="@/assets/images/main/4step/arrow-prev.png" alt="icon" class="cursor-pointer" />
          </li>

          <li class="step-button-next-custom size-11 tablet:size-[52px]">
            <img src="@/assets/images/main/4step/arrow-next.png" alt="icon" class="cursor-pointer" />
          </li>
        </ul>
      </article>

      <article
        v-if="
          homeMainInfo.homeMainInfoDetail.homeMainDetailList.mainContent !== 'adult' &&
          homeMainInfo.homeMainInfoDetail.homeMainDetailList.mainContent !== 'junior'
        "
        class="my-style overflow-hidden"
      >
        <div class="pc-con-wrapper1 py-24 pc:pt-32">
          <div class="mb-10 flex flex-col gap-5 pc:mb-16 pc:gap-10">
            <p class="text-center text-xl font-medium text-neutral-950 pc:text-4xl">
              나만을 위한 수업 스타일과, 나의 실력 향상 스토리까지
            </p>
            <p class="text-center text-3xl font-bold text-neutral-950 pc:text-6xl pc:leading-tight">
              한 발 더 앞선 나를 위한 개인 맞춤형 수업 관리
            </p>
          </div>
          <div class="relative">
            <ul class="mx-auto grid max-w-lg grid-cols-1 gap-16 pc:max-w-none pc:grid-cols-2">
              <li class="flex flex-col items-center gap-8 rounded-2xl bg-white p-12 shadow-xl">
                <p class="text-center text-2xl font-bold text-neutral-950">
                  내가 원하는
                  <span class="text-rose-500">수업 스타일</span>로<br />더 높아지는 학습 효과!
                </p>
                <p class="text-center text-lg text-neutral-950">
                  다 똑같이 구성된 수업은 그만!<br /><span class="font-bold">내가 선택</span>하는
                  <span class="font-bold">내게 가장 알맞은 수업 스타일</span>로<br />더 높아지는 학습 효과를 느껴보세요!
                </p>
                <img src="@/assets/images/main/custom/style.png" alt="수업 방식, 수업 시작, 집중 학습 영역" class="w-min" />
              </li>
              <li class="flex flex-col items-center gap-8 rounded-2xl bg-white p-12 shadow-xl">
                <p class="text-center text-2xl font-bold text-neutral-950">
                  어제보다 성장한<br /><span class="text-rose-500">나의 스토리</span>를 확인하세요!
                </p>
                <p class="text-center text-lg text-neutral-950">
                  떨려서 더 잘하지 못했던 것 같은 첫 수업을 기억하시나요?<br /><span class="font-bold"
                    >나의 수업 스토리를 한눈에</span
                  >
                  확인해 보세요!<br /><span class="font-bold">자신감은 Up 하고 복습 효과는 덤!</span>
                </p>
                <img src="@/assets/images/main/custom/story.png" alt="스토리" class="w-min" />
              </li>
            </ul>
            <div class="absolute -bottom-24 -right-28">
              <img src="@/assets/images/main/custom/up.png" alt="image" class="w-min" />
            </div>
          </div>
        </div>
      </article>

      <article
        v-if="
          homeMainInfo.homeMainInfoDetail.homeMainDetailList.mainContent !== 'adult' &&
          homeMainInfo.homeMainInfoDetail.homeMainDetailList.mainContent !== 'junior'
        "
        class="pc-con-wrapper1 py-24 pc:py-32"
      >
        <div class="mb-10 flex flex-col gap-5 pc:mb-16 pc:gap-10">
          <p class="text-center text-xl font-medium text-neutral-950 pc:text-4xl">언제 어디서나 내맘대로, 맞춤형 수업!</p>
          <p class="text-center text-3xl font-bold text-neutral-950 pc:text-6xl pc:leading-tight">
            바쁜 일정에도 걱정 없이<br />내 스케줄에 맞춰 수업을 들으세요!
          </p>
        </div>
        <div
          class="anywhere mx-auto flex max-w-lg flex-col items-center justify-between gap-10 pc:max-w-none pc:items-start pc:gap-0"
        >
          <ul class="top flex w-full flex-col justify-between gap-10 pc:flex-row pc:gap-16">
            <li class="relative flex w-full justify-between gap-14 bg-white p-10 pc:w-[465px]">
              <div class="flex flex-col gap-2.5">
                <p class="text-lg font-bold text-neutral-950">회수 제한 없는 스케줄 조정</p>
                <p class="text-lg text-neutral-950">
                  여행? 회식? 약속? 그냥 피곤?<br />상관 없어요!<br />내 수업은 횟수제한 없이<br />스케줄 조정이 가능하니까!
                </p>
              </div>
              <div class="absolute bottom-10 right-10 hidden pc:block">
                <img src="@/assets/images/main/anywhere/icon0.png" alt="icon" class="w-min" />
              </div>
            </li>
            <li class="relative flex w-full justify-between gap-14 bg-white p-10 pc:w-[465px]">
              <div class="flex flex-col gap-2.5">
                <p class="text-lg font-bold text-neutral-950">다른 강사님과도 수업해보기</p>
                <p class="text-lg text-neutral-950">
                  다른 강사님 수업도 궁금하신가요?<br />오늘만 강사님을 변경해서<br />부담없이 들어보세요!
                </p>
              </div>
              <div class="absolute bottom-10 right-10 hidden pc:block">
                <img src="@/assets/images/main/anywhere/icon1.png" alt="icon" class="w-min" />
              </div>
            </li>
          </ul>
          <p class="hidden text-center text-4xl font-bold text-white pc:block">이 모든 것이,<br />당근영어의 혜택!</p>
          <ul class="bottom flex w-full flex-col justify-between gap-10 pc:flex-row pc:gap-16">
            <li class="relative flex w-full justify-between gap-14 bg-white p-10 pc:w-[465px]">
              <div class="flex flex-col gap-2.5">
                <p class="text-lg font-bold text-neutral-950">1번의 수업도 놓치지 않도록! 보강 자동 알람</p>
                <p class="text-lg text-neutral-950">
                  미진행된 수업은 보강 알림톡으로<br />보강 수업은 보강 알림 기능으로<br />빠지지 않고 수업을 들을 수 있도록<br />스케줄링
                  가능해요!
                </p>
              </div>
              <div class="absolute bottom-10 right-10 hidden pc:block">
                <img src="@/assets/images/main/anywhere/icon2.png" alt="icon" class="w-min" />
              </div>
            </li>

            <li class="relative flex w-full justify-between gap-14 bg-white p-10 pc:w-[465px]">
              <div class="flex flex-col gap-2.5">
                <p class="text-lg font-bold text-neutral-950">인터넷 환경이라면, 해외에서도 OK!</p>
                <p class="text-lg text-neutral-950">
                  해외 출장이라도,<br />여행 중이라도 인터넷만 연결되면<br />해외에서도 OK!<br />걱정없이 수업을 들을 수 있어요!
                </p>
              </div>
              <div class="absolute bottom-10 right-10 hidden pc:block">
                <img src="@/assets/images/main/anywhere/icon3.png" alt="icon" class="w-min" />
              </div>
            </li>
          </ul>
        </div>
      </article>
    </section>

    <!-- 강원만 -->
    <section v-if="idxLeSiteMain == '138' || idxLeSiteMain == '195'">
      <article class="py-[70px] pc:py-[140px]">
        <p
          class="mx-auto mb-[30px] w-max rounded-2xl border border-solid border-[#3880F2] px-5 py-3.5 text-center text-xl font-semibold text-[#3880F2] pc:mb-9 pc:py-4 pc:text-[28px]"
        >
          맞춤 학습이 실력을 만듭니다!
        </p>

        <p class="mb-5 text-center text-[34px] font-bold text-[#101010] pc:mb-[38px] pc:text-[54px]">
          개인별 수준 및 학습목적을 고려하여<br />
          나에게 맞는 학습을 제공합니다.
        </p>

        <p class="mb-[38px] text-center text-[#424242] pc:mb-[74px] pc:text-2xl">
          입문 학습자부터 고급 레벨 학습자까지<br />
          <!-- 195 는 한국어 과정이므로 "외국어" 만 제외 -->
          다양한 과정으로 나에게 꼭 맞는<template v-if="idxLeSiteMain != '195'"> 외국어</template> 학습을<br class="pc:hidden" />
          경험해 보세요.
        </p>

        <!-- 195(남북하나재단) 한국어 커리큘럼 표 -->
        <template v-if="idxLeSiteMain == '195'">
          <!-- 모바일: 표가 넓어 가로 스크롤 -->
          <div class="overflow-x-auto px-[18px] pc:hidden">
            <img src="@/assets/images/main/hana/curriculum-ko.png" alt="한국어 커리큘럼" class="w-[1200px] min-w-[1200px]" />
          </div>

          <div class="mx-auto hidden max-w-[1200px] pc:block">
            <img src="@/assets/images/main/hana/curriculum-ko.png" alt="한국어 커리큘럼" />
          </div>
        </template>

        <!-- 커리큘럼 표는 강원(138)만 -->
        <div v-if="idxLeSiteMain == '138'" class="space-y-[30px] pc:hidden">
          <div class="overflow-hidden bg-[#F7F7F7] px-[18px] py-3.5">
            <div class="relative overflow-hidden">
              <div class="absolute shadow-[0_6px_30px_0_rgba(0,0,0,0.05)]">
                <img src="@/assets/images/main/gangwon/lang-ch-m.png" alt="" class="w-[86px]" />
              </div>
              <div class="overflow-x-auto rounded-r-xl pl-[86px]">
                <div class="pl-2.5">
                  <img src="@/assets/images/main/gangwon/con-ch-m.png" alt="" class="w-[795px] min-w-[795px]" />
                </div>
              </div>
            </div>
          </div>

          <div class="overflow-hidden bg-[#F7F7F7] px-[18px] py-3.5">
            <div class="relative overflow-hidden">
              <div class="absolute shadow-[0_6px_30px_0_rgba(0,0,0,0.05)]">
                <img src="@/assets/images/main/gangwon/lang-jp-m.png" alt="" class="w-[86px]" />
              </div>
              <div class="overflow-x-auto rounded-r-xl pl-[86px]">
                <div class="pl-2.5">
                  <img src="@/assets/images/main/gangwon/con-jp-m.png" alt="" class="w-[795px] min-w-[795px]" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="idxLeSiteMain == '138'" class="mx-auto hidden max-w-[1200px] space-y-[50px] pc:block">
          <img src="@/assets/images/main/gangwon/con-ch-p.png" alt="" />
          <img src="@/assets/images/main/gangwon/con-jp-p.png" alt="" />
        </div>
      </article>
    </section>

    <!-- 공지사항 -->
    <section v-if="idxLeSiteMain != '52'" class="border-t border-solid border-neutral-300">
      <div class="pc-con-wrapper1 flex items-center justify-between gap-2 py-5 pc:py-9">
        <div class="flex items-center gap-2.5 pc:gap-16">
          <p class="text-lg font-medium text-neutral-950 pc:text-3xl">공지사항</p>
          <p
            v-if="homeMainInfo && homeMainInfo.homeMainInfoDetail && homeMainInfo.homeMainInfoDetail.homeMainNoticeList[0]"
            class="cursor-pointer text-xs text-neutral-500 pc:text-xl"
            @click="homeMainInfo.getNotice"
          >
            {{ homeMainInfo.homeMainInfoDetail.homeMainNoticeList[0].title }}
          </p>
        </div>
        <div class="cursor-pointer" @click="goNoticeList()">
          <img src="@/assets/images/main/notice/more.png" alt="icon" class="w-7 pc:w-min" />
        </div>
      </div>
    </section>

    <!-- 원격지원, 고객센터 -->
    <section v-if="idxLeSiteMain != '52'" class="bg-zinc-100 py-9 pc:py-12">
      <div class="pc-con-wrapper1 flex flex-col gap-9 divide-y divide-solid divide-neutral-300 pc:gap-12">
        <div class="flex flex-col pc:flex-row pc:items-center pc:justify-between">
          <div class="flex flex-col gap-4">
            <p class="text-lg font-medium text-neutral-950 pc:text-3xl">고객센터</p>
            <p class="text-sm font-bold text-neutral-950 pc:text-xl">02-518-0036</p>
          </div>
          <div class="flex flex-col gap-5 pc:flex-row pc:items-center pc:gap-44">
            <p class="text-sm text-neutral-500 pc:text-xl">09:00 - 18:00 주말&공휴일 휴무</p>
            <ul class="flex gap-2.5 pc:grid pc:grid-cols-4 pc:gap-4">
              <li class="cursor-pointer" @click="goSite('https://carrotenglish.com/')">
                <img src="@/assets/images/main/help/sns0.png" alt="당근영어" class="w-12 pc:w-min" />
              </li>
              <li class="cursor-pointer" @click="goSite('https://blog.naver.com/carrotkr6404')">
                <img src="@/assets/images/main/help/sns1.png" alt="네이버 블로그" class="w-12 pc:w-min" />
              </li>
              <li class="cursor-pointer" @click="goSite('https://www.instagram.com/carrotenglish')">
                <img src="@/assets/images/main/help/sns2.png" alt="인스타그램" class="w-12 pc:w-min" />
              </li>
              <li class="cursor-pointer" @click="goSite('https://www.youtube.com/@carrotenglish')">
                <img src="@/assets/images/main/help/sns3.png" alt="유튜브" class="w-12 pc:w-min" />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <div
      v-if="idxLeSiteMain != '52'"
      class="go-inquiry fixed bottom-2 right-2 z-[1] h-[70px] w-[155px] cursor-pointer pc:bottom-10 pc:right-10"
      @click="openChannelTalk"
    >
      <img src="@/assets/images/common/inquiry.png" alt="icon" />
    </div>
  </div>

  <!-- 이벤트 팝업1 -->
  <div v-if="homeMainInfo.homeMainInfoDetail.popupImg1">
    <div
      class="fixed left-0 top-0 z-[2] h-full w-full overflow-y-auto pc:absolute pc:left-1/2 pc:top-[300px] pc:h-auto pc:w-auto pc:-translate-x-1/2"
      v-if="isPopup1Visible"
    >
      <div class="flex min-h-full items-center justify-center p-5">
        <div
          class="mx-auto flex max-w-[850px] flex-col items-center justify-center border border-solid border-neutral-300 bg-white"
        >
          <div class="w-full cursor-pointer bg-green-500 pr-5 text-right text-xl" @click="closePopup1">X</div>
          <div class="content">
            <div>
              <img :src="homeMainInfo.homeMainInfoDetail.popupImg1" alt="img" class="aspect-square" />
            </div>
            <ul class="flex">
              <li class="w-1/2 grow cursor-pointer border-r border-solid border-neutral-300 p-2.5 text-center">
                <a @click="closePopup1OneDay">오늘하루 보지 않기</a>
              </li>
              <li class="w-1/2 grow cursor-pointer p-2.5 text-center">
                <a @click="closePopup1">닫기</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 이벤트 팝업2 -->
  <div v-if="homeMainInfo.homeMainInfoDetail.popupImg2">
    <div
      class="fixed left-0 top-0 z-[2] h-full w-full overflow-y-auto pc:absolute pc:left-1/2 pc:top-[400px] pc:h-auto pc:w-auto pc:-translate-x-1/2"
      v-if="isPopup2Visible"
    >
      <div class="flex min-h-full items-center justify-center p-5">
        <div
          class="mx-auto flex max-w-[850px] flex-col items-center justify-center border border-solid border-neutral-300 bg-white"
        >
          <div class="w-full cursor-pointer bg-red-500 pr-5 text-right text-xl" @click="closePopup2">X</div>
          <div class="content">
            <div>
              <img :src="homeMainInfo.homeMainInfoDetail.popupImg2" alt="img" class="aspect-square" />
            </div>
            <ul class="flex">
              <li class="w-1/2 grow cursor-pointer border-r border-solid border-neutral-300 p-2.5 text-center">
                <a @click="closePopup2OneDay">오늘하루 보지 않기</a>
              </li>
              <li class="w-1/2 grow cursor-pointer p-2.5 text-center">
                <a @click="closePopup2">닫기</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 이벤트 팝업3 -->
  <div v-if="homeMainInfo.homeMainInfoDetail.popupImg3">
    <div
      class="fixed left-0 top-0 z-[2] h-full w-full overflow-y-auto pc:absolute pc:left-1/2 pc:top-[500px] pc:h-auto pc:w-auto pc:-translate-x-1/2"
      v-if="isPopup3Visible"
    >
      <div class="flex min-h-full items-center justify-center p-5">
        <div
          class="mx-auto flex max-w-[850px] flex-col items-center justify-center border border-solid border-neutral-300 bg-white"
        >
          <div class="w-full cursor-pointer bg-blue-500 pr-5 text-right text-xl" @click="closePopup3">X</div>
          <div class="content">
            <div>
              <img :src="homeMainInfo.homeMainInfoDetail.popupImg3" alt="img" class="aspect-square" />
            </div>
            <ul class="flex">
              <li class="w-1/2 grow cursor-pointer border-r border-solid border-neutral-300 p-2.5 text-center">
                <a @click="closePopup3OneDay">오늘하루 보지 않기</a>
              </li>
              <li class="w-1/2 grow cursor-pointer p-2.5 text-center">
                <a @click="closePopup3">닫기</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 이벤트 팝업4 -->
  <div v-if="homeMainInfo.homeMainInfoDetail.popupImg4">
    <div
      class="fixed left-0 top-0 z-[2] h-full w-full overflow-y-auto pc:absolute pc:left-1/2 pc:top-[600px] pc:h-auto pc:w-auto pc:-translate-x-1/2"
      v-if="isPopup4Visible"
    >
      <div class="flex min-h-full items-center justify-center p-5">
        <div
          class="mx-auto flex max-w-[850px] flex-col items-center justify-center border border-solid border-neutral-300 bg-white"
        >
          <div class="w-full cursor-pointer bg-lime-500 pr-5 text-right text-xl" @click="closePopup4">X</div>
          <div class="content">
            <div>
              <img :src="homeMainInfo.homeMainInfoDetail.popupImg4" alt="img" class="aspect-square" />
            </div>
            <ul class="flex">
              <li class="w-1/2 grow cursor-pointer border-r border-solid border-neutral-300 p-2.5 text-center">
                <a @click="closePopup4OneDay">오늘하루 보지 않기</a>
              </li>
              <li class="w-1/2 grow cursor-pointer p-2.5 text-center">
                <a @click="closePopup4">닫기</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 이벤트 팝업5 -->
  <div v-if="homeMainInfo.homeMainInfoDetail.popupImg5">
    <div
      class="fixed left-0 top-0 z-[2] h-full w-full overflow-y-auto pc:absolute pc:left-1/2 pc:top-[700px] pc:h-auto pc:w-auto pc:-translate-x-1/2"
      v-if="isPopup5Visible"
    >
      <div class="flex min-h-full items-center justify-center p-5">
        <div
          class="mx-auto flex max-w-[850px] flex-col items-center justify-center border border-solid border-neutral-300 bg-white"
        >
          <div class="w-full cursor-pointer bg-purple-500 pr-5 text-right text-xl" @click="closePopup5">X</div>
          <div class="content">
            <div>
              <img :src="homeMainInfo.homeMainInfoDetail.popupImg5" alt="img" class="aspect-square" />
            </div>
            <ul class="flex">
              <li class="w-1/2 grow cursor-pointer border-r border-solid border-neutral-300 p-2.5 text-center">
                <a @click="closePopup5OneDay">오늘하루 보지 않기</a>
              </li>
              <li class="w-1/2 grow cursor-pointer p-2.5 text-center">
                <a @click="closePopup5">닫기</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, computed, onMounted, onUnmounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { Swiper, SwiperSlide } from "swiper/vue";
import { FreeMode, Thumbs, Pagination, Autoplay, Navigation } from "swiper/modules";
import axios from "@/plugins/axios.js";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/thumbs";
import "swiper/css/pagination";
import "swiper/css/navigation";
import * as ChannelService from "@channel.io/channel-web-sdk-loader";
import { setReplayUserId } from "@/plugins/sessionReplay.js";
import CompLoading from "@/components/CompLoading.vue";

export default {
  components: {
    Swiper,
    SwiperSlide,
    CompLoading,
  },
  setup() {
    const isLoading = ref(true);

    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    const openChannelTalk = () => {
      ChannelService.loadScript();
      ChannelService.boot({
        pluginKey: "652f8e43-1d56-41b7-b594-bd6c8f2bd4e4",
        hideChannelButtonOnBoot: true,
      });
      ChannelService.openChat();
    };

    let idxLeSiteMain = "";
    // 로컬 테스트용
    // if (route.query.idxLeSiteMain) {
    //   idxLeSiteMain = route.query.idxLeSiteMain;
    // 실서버 운영용
    if (store.getters.getIdxLeSiteMain) {
      idxLeSiteMain = store.getters.getIdxLeSiteMain;
      store.commit("setIdxLeSiteMain", idxLeSiteMain);
    } else if (store.getters.getIdxLeSiteMain != "") {
      idxLeSiteMain = store.getters.getIdxLeSiteMain;
    }

    const goPage = (path, query) => {
      if (query && Object.keys(query).length > 0) {
        router.push({ path, query });
        return;
      }
      router.push(path);
    };

    const goSite = (url) => {
      window.open(url, "_blank");
    };

    const goToSugang = (url) => {
      window.location.href = url;
    };

    const goSmooth = (idx) => {
      document.getElementById(idx).scrollIntoView({ behavior: "smooth" });
    };

    const currentNoticeIdx = computed(() => visibleNotices.value?.[0]?.idxNotice ?? "");

    const goNoticeList = () => {
      const query = currentNoticeIdx.value ? { idxNotice: currentNoticeIdx.value } : {};
      goPage("/learningSupport/noticeList", query);
    };

    // 팝업 오늘하루, 닫기
    const isPopup1Visible = ref(true);
    const isPopup2Visible = ref(true);
    const isPopup3Visible = ref(true);
    const isPopup4Visible = ref(true);
    const isPopup5Visible = ref(true);

    // 팝업1
    const getPopupKey1 = () => {
      // 현재 사이트의 고유한 키를 생성하는 로직
      const siteKey = `site_${store.getters.getIdxLeSiteMain || "default"}`;
      return `lastHiddenTime1_${siteKey}`;
    };

    const closePopup1OneDay = () => {
      isPopup1Visible.value = false;
      const currentDate = new Date();
      const lastHiddenTimeKey = getPopupKey1();
      localStorage.setItem(lastHiddenTimeKey, currentDate.getTime());
    };

    const closePopup1 = () => {
      isPopup1Visible.value = false;
    };

    // 화면 로딩 시 팝업 상태 초기화
    const initializePopup1State = () => {
      isPopup1Visible.value = !isHiddenToday1();
    };

    const isHiddenToday1 = () => {
      const lastHiddenTimeKey = getPopupKey1();
      const lastHiddenTime = localStorage.getItem(lastHiddenTimeKey);

      if (!lastHiddenTime) return false;

      const currentDate = new Date();
      return currentDate.getTime() - parseInt(lastHiddenTime) < 23 * 60 * 60 * 1000;
    };

    // 팝업2
    const getPopupKey2 = () => {
      // 현재 사이트의 고유한 키를 생성하는 로직
      const siteKey = `site_${store.getters.getIdxLeSiteMain || "default"}`;
      return `lastHiddenTime2_${siteKey}`;
    };

    const closePopup2OneDay = () => {
      isPopup2Visible.value = false;
      const currentDate = new Date();
      const lastHiddenTimeKey = getPopupKey2();
      localStorage.setItem(lastHiddenTimeKey, currentDate.getTime());
    };

    const closePopup2 = () => {
      isPopup2Visible.value = false;
    };

    // 화면 로딩 시 팝업 상태 초기화
    const initializePopup2State = () => {
      isPopup2Visible.value = !isHiddenToday2();
    };

    const isHiddenToday2 = () => {
      const lastHiddenTimeKey = getPopupKey2();
      const lastHiddenTime = localStorage.getItem(lastHiddenTimeKey);

      if (!lastHiddenTime) return false;

      const currentDate = new Date();
      return currentDate.getTime() - parseInt(lastHiddenTime) < 23 * 60 * 60 * 1000;
    };

    // 팝업3
    const getPopupKey3 = () => {
      // 현재 사이트의 고유한 키를 생성하는 로직
      const siteKey = `site_${store.getters.getIdxLeSiteMain || "default"}`;
      return `lastHiddenTime3_${siteKey}`;
    };

    const closePopup3OneDay = () => {
      isPopup3Visible.value = false;
      const currentDate = new Date();
      const lastHiddenTimeKey = getPopupKey3();
      localStorage.setItem(lastHiddenTimeKey, currentDate.getTime());
    };

    const closePopup3 = () => {
      isPopup3Visible.value = false;
    };

    // 화면 로딩 시 팝업 상태 초기화
    const initializePopup3State = () => {
      isPopup3Visible.value = !isHiddenToday3();
    };

    const isHiddenToday3 = () => {
      const lastHiddenTimeKey = getPopupKey3();
      const lastHiddenTime = localStorage.getItem(lastHiddenTimeKey);

      if (!lastHiddenTime) return false;

      const currentDate = new Date();
      return currentDate.getTime() - parseInt(lastHiddenTime) < 23 * 60 * 60 * 1000;
    };

    // 팝업4
    const getPopupKey4 = () => {
      // 현재 사이트의 고유한 키를 생성하는 로직
      const siteKey = `site_${store.getters.getIdxLeSiteMain || "default"}`;
      return `lastHiddenTime4_${siteKey}`;
    };

    const closePopup4OneDay = () => {
      isPopup4Visible.value = false;
      const currentDate = new Date();
      const lastHiddenTimeKey = getPopupKey4();
      localStorage.setItem(lastHiddenTimeKey, currentDate.getTime());
    };

    const closePopup4 = () => {
      isPopup4Visible.value = false;
    };

    // 화면 로딩 시 팝업 상태 초기화
    const initializePopup4State = () => {
      isPopup4Visible.value = !isHiddenToday4();
    };

    const isHiddenToday4 = () => {
      const lastHiddenTimeKey = getPopupKey4();
      const lastHiddenTime = localStorage.getItem(lastHiddenTimeKey);

      if (!lastHiddenTime) return false;

      const currentDate = new Date();
      return currentDate.getTime() - parseInt(lastHiddenTime) < 23 * 60 * 60 * 1000;
    };

    // 팝업5
    const getPopupKey5 = () => {
      // 현재 사이트의 고유한 키를 생성하는 로직
      const siteKey = `site_${store.getters.getIdxLeSiteMain || "default"}`;
      return `lastHiddenTime5_${siteKey}`;
    };

    const closePopup5OneDay = () => {
      isPopup5Visible.value = false;
      const currentDate = new Date();
      const lastHiddenTimeKey = getPopupKey5();
      localStorage.setItem(lastHiddenTimeKey, currentDate.getTime());
    };

    const closePopup5 = () => {
      isPopup5Visible.value = false;
    };

    // 화면 로딩 시 팝업 상태 초기화
    const initializePopup5State = () => {
      isPopup5Visible.value = !isHiddenToday5();
    };

    const isHiddenToday5 = () => {
      const lastHiddenTimeKey = getPopupKey5();
      const lastHiddenTime = localStorage.getItem(lastHiddenTimeKey);

      if (!lastHiddenTime) return false;

      const currentDate = new Date();
      return currentDate.getTime() - parseInt(lastHiddenTime) < 23 * 60 * 60 * 1000;
    };

    // 커리큘럼 슬라이더
    const thumbsSwiper = ref(null);
    const setThumbsSwiper = (swiper) => {
      thumbsSwiper.value = swiper;
    };

    const thumbsCon4Swiper = ref(null);
    const setThumbsCon4Swiper = (swiper) => {
      thumbsCon4Swiper.value = swiper;
    };

    // 공지사항 롤링 기능
    const noticeRollingIndex = ref(0);
    let noticeRollingInterval = null;

    // 공지사항 롤링 시작
    const startNoticeRolling = () => {
      if (homeMainInfo.homeMainInfoDetail.homeMainNoticeList?.length <= 1) return;

      noticeRollingInterval = setInterval(() => {
        noticeRollingIndex.value = (noticeRollingIndex.value + 1) % homeMainInfo.homeMainInfoDetail.homeMainNoticeList.length;
      }, 3000); // 3초마다 변경
    };

    // 공지사항 롤링 정지
    const stopNoticeRolling = () => {
      if (noticeRollingInterval) {
        clearInterval(noticeRollingInterval);
        noticeRollingInterval = null;
      }
    };

    const homeMainInfo = reactive({
      homeMainInfoDetail: {
        idxLeSiteMain: idxLeSiteMain,
        pageNum: 1,
        pageSize: 50,
        homeMainDetailList: [],
        homeMainNoticeList: [],
        idxCompany: "",
        isAdult: "",
        popupImg1: "",
        popupImg2: "",
        popupImg3: "",
        popupImg4: "",
        popupImg5: "",
      },

      openGlobalsugang() {
        const token = store.getters.getAccessToken;
        const params = {
          token: token,
        };

        axios.get(`/user/auth/token`, { params }).then(function (res) {
          if (res.data.success === true) {
            setReplayUserId(store.state.userId);

            window.location.href = `https://apply.carrotglobal.com/lnk/busanedu?id=${store.state.userId}&accesscode=2024`;
          } else {
            alert("로그인이 필요한 서비스 입니다.");
            router.push({
              path: "/login/login",
            });
          }
        });
      },

      opencheckGlobalsugang() {
        const token = store.getters.getAccessToken;
        const params = {
          token: token,
        };
        axios.get(`/user/auth/token`, { params }).then(function (res) {
          if (res.data.success === true) {
            setReplayUserId(store.state.userId);

            if (location.origin.includes("stage")) {
              window.location.href = "https://stage-itmsugang.carrotenglish.net/lnk/hunitest?loginPageMode=history";
            } else {
              window.location.href = "https://apply.carrotglobal.com/lnk/busanedu?loginPageMode=history";
            }
          } else {
            alert("로그인이 필요한 서비스 입니다.");
            router.push({
              path: "/login/login",
            });
          }
        });
      },
      goEnrolmentJunior() {
        const token = store.getters.getAccessToken;
        const params = {
          token: token,
        };
        axios.get(`/user/auth/token`, { params }).then(function (res) {
          if (res.data.success === true) {
            setReplayUserId(store.state.userId);

            if (homeMainInfo.homeMainInfoDetail.isAdult === "N") {
              router.push({
                path: "/enrolment/newEnrolment",
              });
            } else if (homeMainInfo.homeMainInfoDetail.isAdult === "Y") {
              alert("성인은 주니어과정을 신청하실 수 없습니다. 성인과정을 신청해주세요.");
            }
          } else {
            alert("로그인이 필요한 서비스 입니다.");
            router.push({
              path: "/login/login",
            });
          }
        });
      },

      goEnrolmentAdult() {
        const token = store.getters.getAccessToken;
        const params = {
          token: token,
        };
        axios.get(`/user/auth/token`, { params }).then(function (res) {
          if (res.data.success === true) {
            setReplayUserId(store.state.userId);

            if (homeMainInfo.homeMainInfoDetail.isAdult === "Y") {
              router.push({
                path: "/enrolment/newEnrolment",
              });
            } else if (homeMainInfo.homeMainInfoDetail.isAdult === "N") {
              alert("주니어는 성인과정을 신청하실 수 없습니다. 주니어과정을 신청해주세요.");
            }
          } else {
            alert("로그인이 필요한 서비스 입니다.");
            router.push({
              path: "/login/login",
            });
          }
        });
      },

      goClassList() {
        const token = store.getters.getAccessToken;
        const params = {
          token: token,
        };
        axios.get(`/user/auth/token`, { params }).then(function (res) {
          if (res.data.success === true) {
            setReplayUserId(store.state.userId);

            router.push({
              path: "/enrolment/classList",
            });
          } else {
            alert("로그인이 필요한 서비스 입니다.");
            router.push({
              path: "/login/login",
            });
          }
        });
      },

      goMyClass() {
        const token = store.getters.getAccessToken;
        const params = {
          token: token,
        };
        axios.get(`/user/auth/token`, { params }).then(function (res) {
          if (res.data.success === true) {
            setReplayUserId(store.state.userId);

            router.push({
              path: "/myClass",
            });
          } else {
            alert("로그인이 필요한 서비스 입니다.");
            router.push({
              path: "/login/login",
            });
          }
        });
      },

      async getSiteMain() {
        // idx 가 있을 때만 조회한다. 빈 idx 로 호출하면 백엔드가 500(값을 확인해주세요)을 주고 alert 이 뜬다.
        if (!idxLeSiteMain) return;

        const params = {
          idxLeSiteMain,
        };

        try {
          const res = await axios.get(`/user/page/siteMain`, { params });

          if (res.data.success === true) {
            homeMainInfo.homeMainInfoDetail.homeMainDetailList = res.data.data;
            const companyLogo = homeMainInfo.homeMainInfoDetail.homeMainDetailList.companyLogo;
            homeMainInfo.homeMainInfoDetail.idxCompany = res.data.data.idxCompany;
            homeMainInfo.homeMainInfoDetail.isAdult = res.data.data.isAdult;
            store.commit("setIsQuestion", res.data.data.isQuestion);
            store.dispatch("setCompanyLogo", companyLogo);
            store.commit("setIdxCompany", res.data.data.idxCompany);
            store.commit("setIsCancleFunction", res.data.data.isCancleFunction);
            homeMainInfo.homeMainInfoDetail.popupImg1 = res.data.data.popupImg1;
            homeMainInfo.homeMainInfoDetail.popupImg2 = res.data.data.popupImg2;
            homeMainInfo.homeMainInfoDetail.popupImg3 = res.data.data.popupImg3;
            homeMainInfo.homeMainInfoDetail.popupImg4 = res.data.data.popupImg4;
            homeMainInfo.homeMainInfoDetail.popupImg5 = res.data.data.popupImg5;
            homeMainInfo.homeMainInfoDetail.button1Link = res.data.data.button1Link;
            homeMainInfo.homeMainInfoDetail.button1Name = res.data.data.button1Name;
            homeMainInfo.homeMainInfoDetail.button2Link = res.data.data.button2Link;
            homeMainInfo.homeMainInfoDetail.button2Name = res.data.data.button2Name;
            homeMainInfo.homeMainInfoDetail.button3Link = res.data.data.button3Link;
            homeMainInfo.homeMainInfoDetail.button3Name = res.data.data.button3Name;
            homeMainInfo.homeMainInfoDetail.button4Link = res.data.data.button4Link;
            homeMainInfo.homeMainInfoDetail.button4Name = res.data.data.button4Name;
          } else {
            // 사이트 데이터가 없으면(없는/잘못된 idx) 404 로 보낸다. 이미 /notFound 면 루프 방지로 스킵.
            if (route.path !== "/notFound") {
              router.replace("/notFound");
            }
          }
        } catch (error) {
          console.error("Error loading site main:", error);
        }
      },

      async getNoticeList() {
        const params = {
          idxLeSiteMain: idxLeSiteMain,
          pageNum: homeMainInfo.homeMainInfoDetail.pageNum,
          pageSize: homeMainInfo.homeMainInfoDetail.pageSize,
        };

        try {
          const res = await axios.get(`/user/page/noticeList`, { params });

          if (res.data.success === true) {
            homeMainInfo.homeMainInfoDetail.homeMainNoticeList = res.data.data;

            // 공지사항 데이터 로드 후 롤링 시작
            stopNoticeRolling();
            noticeRollingIndex.value = 0;
            if (res.data.data?.length > 1) {
              startNoticeRolling();
            }
          } else {
            alert(res.data.message);
          }
        } catch (error) {
          console.error("Error loading notice list:", error);
        }
      },

      getNotice() {
        const idxNotice = homeMainInfo.homeMainInfoDetail.homeMainNoticeList[noticeRollingIndex.value].idxNotice;
        const idxLeSiteMain = store.getters.getIdxLeSiteMain;

        axios.get(`/user/page/notice?idxLeSiteMain=${idxLeSiteMain}&idxNotice=${idxNotice}`).then(function (res) {
          if (res.data.success === true) {
            router.push({
              path: "/learningSupport/noticeDetail",
              query: {
                idxNotice: idxNotice,
              },
            });
          } else {
            alert(res.data.message);
          }
        });
      },
    });

    // 과정명에 포함된 <br> 표기를 실제 줄바꿈으로 렌더링하기 위한 분리
    const sugangNameLines = computed(() => {
      const sugangName = homeMainInfo.homeMainInfoDetail.homeMainDetailList.sugangName || "";
      return sugangName.split(/<br\s*\/?>/i);
    });

    // 공지사항 표시용 computed 속성
    const visibleNotices = computed(() => {
      if (!homeMainInfo.homeMainInfoDetail.homeMainNoticeList?.length) return [];
      return [homeMainInfo.homeMainInfoDetail.homeMainNoticeList[noticeRollingIndex.value]];
    });

    // 공지사항 개수 변화 감지
    watch(
      () => homeMainInfo.homeMainInfoDetail.homeMainNoticeList?.length,
      (newLength) => {
        stopNoticeRolling();
        noticeRollingIndex.value = 0;
        if (newLength > 1) {
          startNoticeRolling();
        }
        0;
      }
    );

    const getToken = async () => {
      try {
        const token = store.getters.getAccessToken;
        const params = {
          token: token,
        };

        const result = await axios.get(`/user/auth/token`, { params });
        const {
          success,
          data: { isHr, hrKey },
        } = result.data;

        if (!success) {
          store.commit("setAccessToken", null);
          store.commit("setHrInfo", {
            isHr: "N",
            hrKey: "",
          });
        } else {
          store.commit("setHrInfo", {
            isHr,
            hrKey,
          });
        }
      } catch (error) {
        console.error("Error fetching token:", error);
        store.commit("setAccessToken", null);
      }
    };

    onMounted(async () => {
      try {
        isLoading.value = true;

        await getToken();

        await Promise.all([homeMainInfo.getSiteMain(), homeMainInfo.getNoticeList()]);

        initializePopup1State();
        initializePopup2State();
        initializePopup3State();
        initializePopup4State();
        initializePopup5State();
      } finally {
        isLoading.value = false;
      }
    });

    // 컴포넌트 언마운트 시 interval 정리
    onUnmounted(() => {
      stopNoticeRolling();
    });

    return {
      isLoading,
      idxLeSiteMain,
      thumbsSwiper,
      setThumbsSwiper,
      thumbsCon4Swiper,
      setThumbsCon4Swiper,
      Swiper,
      SwiperSlide,

      // 팝업 오늘하루, 닫기
      isPopup1Visible, // 팝업1
      isPopup2Visible, // 팝업2
      isPopup3Visible, // 팝업3
      isPopup4Visible, // 팝업4
      isPopup5Visible, // 팝업5

      // 팝업1 상태 관리
      closePopup1OneDay,
      closePopup1,
      initializePopup1State,

      // 팝업2 상태 관리
      closePopup2OneDay,
      closePopup2,
      initializePopup2State,

      // 팝업3 상태 관리
      closePopup3OneDay,
      closePopup3,
      initializePopup3State,

      // 팝업4 상태 관리
      closePopup4OneDay,
      closePopup4,
      initializePopup4State,

      // 팝업5 상태 관리
      closePopup5OneDay,
      closePopup5,
      initializePopup5State,

      // 공지사항 롤링
      noticeRollingIndex,
      visibleNotices, // 추가
      sugangNameLines,
      currentNoticeIdx,
      goNoticeList,

      // 그 외
      currentRoute: route,
      modules: [FreeMode, Thumbs, Pagination, Autoplay, Navigation],
      goPage,
      goSite,
      goToSugang,
      goSmooth,
      homeMainInfo,
      openChannelTalk,
    };
  },
};
</script>

<style scoped>
@media screen and (min-width: 1200px) {
  .curriculum::after {
    content: "";
    position: absolute;
    width: 673px;
    height: 573px;
    background: url(@/assets/images/main/curriculum/content-bg.png) no-repeat;
    right: -300px;
    bottom: -100px;
    z-index: 1;
  }
}

.curriculum-list .swiper-wrapper .swiper-slide-thumb-active {
  color: #fff;
  background-color: #ea580c;
  border-radius: 50px;
  overflow-x: auto;
}

:deep(.curriculum-list) .swiper-wrapper {
  display: grid !important;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  grid-auto-flow: row;
  gap: 20px;
}

.curriculum-list .swiper-wrapper .swiper-slide {
  width: 100% !important;
}

.curriculum-content .swiper-wrapper .swiper-slide:nth-child(1) > div {
  background: url(@/assets/images/main/curriculum/slide0-bg.png) no-repeat right bottom / contain;
}
.curriculum-content .swiper-wrapper .swiper-slide:nth-child(2) > div {
  background: url(@/assets/images/main/curriculum/slide1-bg.png) no-repeat right bottom / contain;
}
.curriculum-content .swiper-wrapper .swiper-slide:nth-child(3) > div {
  background: url(@/assets/images/main/curriculum/slide2-bg.png) no-repeat right bottom / contain;
}
.curriculum-content .swiper-wrapper .swiper-slide:nth-child(4) > div {
  background: url(@/assets/images/main/curriculum/slide3-bg.png) no-repeat right bottom / contain;
}
.curriculum-content .swiper-wrapper .swiper-slide:nth-child(5) > div {
  background: url(@/assets/images/main/curriculum/slide4-bg.png) no-repeat right bottom / contain;
}
.curriculum-content .swiper-wrapper .swiper-slide:nth-child(6) > div {
  background: url(@/assets/images/main/curriculum/slide5-bg.png) no-repeat right bottom / contain;
}
.curriculum-content .swiper-wrapper .swiper-slide:nth-child(7) > div {
  background: url(@/assets/images/main/curriculum/slide6-bg.png) no-repeat right bottom / contain;
}

:deep(.custom-slide) .swiper-pagination {
  bottom: 0;
}

.my-style {
  background: #f4f4f4 url(@/assets/images/main/custom/bg.png) no-repeat center bottom / contain;
}

@media screen and (min-width: 1200px) {
  .anywhere {
    background: url(@/assets/images/main/anywhere/bg.png) no-repeat center / 492px 490px;
  }

  .anywhere > ul.top > li:nth-of-type(1) {
    background: #fff url(@/assets/images/main/anywhere/num0.png) no-repeat right bottom / 50px;
  }
  .anywhere > ul.top > li:nth-of-type(2) {
    background: #fff url(@/assets/images/main/anywhere/num1.png) no-repeat left bottom / 50px;
  }
  .anywhere > ul.bottom > li:nth-of-type(1) {
    background: #fff url(@/assets/images/main/anywhere/num2.png) no-repeat right top / 50px;
  }
  .anywhere > ul.bottom > li:nth-of-type(2) {
    background: #fff url(@/assets/images/main/anywhere/num3.png) no-repeat left top / 50px;
  }
}

.anywhere > ul > li {
  box-shadow: -2px -1px 9px #ccc;
}

@media screen and (min-width: 768px) {
  :deep(.title-slide) .swiper-wrapper {
    justify-content: center;
    gap: 46px;
  }

  :deep(.title-slide) .swiper-wrapper .swiper-slide {
    width: auto !important;
  }
}

@media screen and (min-width: 1200px) {
  :deep(.title-slide) .swiper-wrapper {
    justify-content: center;
    gap: 60px;
  }
}

:deep(.title-slide) .swiper-wrapper .swiper-slide.swiper-slide-thumb-active p {
  color: #111111;
  font-weight: bold;
}

:deep(.title-slide) .swiper-wrapper .swiper-slide:nth-of-type(1).swiper-slide-thumb-active img {
  content: url("@/assets/images/main/solution/title1-on.png");
}

:deep(.title-slide) .swiper-wrapper .swiper-slide:nth-of-type(2).swiper-slide-thumb-active img {
  content: url("@/assets/images/main/solution/title2-on.png");
}

:deep(.title-slide) .swiper-wrapper .swiper-slide:nth-of-type(3).swiper-slide-thumb-active img {
  content: url("@/assets/images/main/solution/title3-on.png");
}

:deep(.title-slide) .swiper-wrapper .swiper-slide:nth-of-type(4).swiper-slide-thumb-active img {
  content: url("@/assets/images/main/solution/title4-on.png");
}

:deep(.step-swiper) .swiper-wrapper {
  align-items: stretch;
  height: auto;
}

:deep(.step-swiper) .swiper-wrapper .swiper-slide:not(.swiper-slide-active) {
  transform: scale(0.8);
}

.notice-slide-enter-active,
.notice-slide-leave-active {
  transition: all 0.5s ease;
}

.notice-slide-enter-from {
  transform: translateY(100%);
  opacity: 0;
}

.notice-slide-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}

.notice-slide-enter-to,
.notice-slide-leave-from {
  transform: translateY(0);
  opacity: 1;
}
</style>
